/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MissionControllerDtoBasicAccountPointLogListRequest model module.
 * @module model/MissionControllerDtoBasicAccountPointLogListRequest
 * @version 1.0
 */
class MissionControllerDtoBasicAccountPointLogListRequest {
    /**
     * Constructs a new <code>MissionControllerDtoBasicAccountPointLogListRequest</code>.
     * @alias module:model/MissionControllerDtoBasicAccountPointLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        MissionControllerDtoBasicAccountPointLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>MissionControllerDtoBasicAccountPointLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoBasicAccountPointLogListRequest} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoBasicAccountPointLogListRequest} The populated <code>MissionControllerDtoBasicAccountPointLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoBasicAccountPointLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoBasicAccountPointLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoBasicAccountPointLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MissionControllerDtoBasicAccountPointLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

MissionControllerDtoBasicAccountPointLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
MissionControllerDtoBasicAccountPointLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
MissionControllerDtoBasicAccountPointLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
MissionControllerDtoBasicAccountPointLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
MissionControllerDtoBasicAccountPointLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
MissionControllerDtoBasicAccountPointLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {Number} accountNo
 */
MissionControllerDtoBasicAccountPointLogListRequest.prototype['accountNo'] = undefined;






export default MissionControllerDtoBasicAccountPointLogListRequest;

